import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom"
//
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from './modules/theme'
//
import AppAppBar from './modules/views/AppAppBar'
import AppFooter from './modules/views/AppFooter'
//
import Home from './Home'
import About from './About'
import Ministry from './Ministry'
import Resources from './Resources'
import NotFound from './NotFound'


const App = () => {
    return (
        <>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <BrowserRouter>
                    <AppAppBar />
                    <Routes>
                        <Route path="/" index element={ <Home/> } />
                        <Route path="/about" element={ <About/> } />
                        <Route path="/ministry" element={ <Ministry/> } />
                        <Route path="/resources" element={ <Resources/> } />
                        <Route path="*" element={ <NotFound/> } />
                    </Routes>
                    <AppFooter />
                </BrowserRouter>
            </ThemeProvider>
        </>
    )
}

export default App
